export default __webpack_public_path__ + "static/media/PHK基金会.ee37af4d.jpg";